import { styled } from '@uhg-abyss/web/tools/styled';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { I18nProvider } from '@uhg-abyss/web/ui/I18nProvider';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import find from 'lodash/find';
import React, { useContext, useState } from 'react';

import { PortalContext } from '../../context/PortalContext';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { useLagoon } from '../../hooks/useLagoon';
import { ConstantsLagoon } from '../ConstantsLagoon';
import { isLawwMember } from '../Utils/memberUtils/memberUtils';

const LAWWBackgroundWrapper = styled('div', {
  backgroundColor: '$lightBlue',
  width: '100%',
});

const LAWWContentWrapper = styled('div', {
  maxWidth: '1200px',
  marginLeft: 'auto',
  marginRight: 'auto',
  padding: '0',

  '@media (max-width: 1248px)': {
    marginLeft: '24px',
    marginRight: '24px',
  },
  '@media (max-width: 744px)': {
    marginLeft: '16px',
    marginRight: '16px',
  },
});

const MessageAlertContainer = styled(Alert, {
  '&.abyss-alert-root': {
    padding: '0px',
    backgroundColor: '$lightBlue',
    border: 'none !important',
    boxShadow: 'none !important',
    outline: 'none !important',
    margin: '0 !important',
    '.abyss-alert-wrapper': {
      maxWidth: 'none',
      backgroundColor: '$lightBlue',
      border: 'none !important',
      boxShadow: 'none !important',
      margin: '0 !important',
      padding: '16px !important',
      '.abyss-alert-title': {
        color: '$uhcPrimary1 !important',
        fontFamily: '$heading !important',
        fontWeight: '600 !important',
      },
      '.abyss-alert-content': {
        color: '$uhcPrimary1',
      },
    },
  },
});

export const CustomMessageNotificationsLaww = () => {
  const [isMessageDismissed, setIsMessageDismissed] = useState(false);

  const { portalData } = useContext(PortalContext);

  const customMesssgeAll = useLagoon('custom-messages')();

  const customMessageNotificationLaww = find(customMesssgeAll, {
    policyNumber: portalData?.portalConfig?.accessCode,
    active: true,
  });

  const [isLawwMessageEnabled] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_CUSTOM_MESSAGE_NOTIFICATION_LAWW,
  ]);

  const shouldShowMessage =
    isLawwMember(portalData?.portalName) &&
    isLawwMessageEnabled &&
    !isMessageDismissed &&
    customMessageNotificationLaww?.message;

  const handleMessageClose = () => {
    setIsMessageDismissed(true);
  };

  if (!shouldShowMessage) {
    return null;
  }

  const { title, message, link, linkText } =
    customMessageNotificationLaww || {};

  return (
    <React.Fragment>
      <LAWWBackgroundWrapper>
        <LAWWContentWrapper>
          <I18nProvider translations={{ close: 'Close message' }}>
            <MessageAlertContainer
              data-auto-testid={`laww-custom-message-container`}
              data-testid={`laww-custom-message-container`}
              onClose={handleMessageClose}
              showDivider={false}
              status="info"
              title={title}
            >
              <Layout.Stack alignItems="left">
                <span dangerouslySetInnerHTML={{ __html: message }} />

                {linkText && link && (
                  <a
                    data-auto-testid="laww-custom-message-link"
                    data-testid="laww-custom-message-link"
                    href={link}
                    target="_blank"
                  >
                    {linkText}
                  </a>
                )}
              </Layout.Stack>
            </MessageAlertContainer>
          </I18nProvider>
        </LAWWContentWrapper>
      </LAWWBackgroundWrapper>
    </React.Fragment>
  );
};
